import React from 'react';

import { COLORS } from 'Components/foundation';
import UIndicator from 'Components/unit/UIndicator/UIndicator';

import styles from '../Item.styles';

export interface ActivityTypeMapItem {
  label: string;
  backgroundColor: keyof typeof COLORS.ACTIVITY;
  colorLabel: keyof typeof COLORS.ACTIVITY;
}

interface ActivityTypeAndIdProps {
  activityId: number;
  type: string;
  activityTypeMap: Record<string, ActivityTypeMapItem>;
}

const ActivityTypeAndId: React.FC<ActivityTypeAndIdProps> = ({ activityId, type, activityTypeMap }) => (
  <div style={styles.containerType}>
    <UIndicator
      text={activityTypeMap[type].label}
      style={{
        backgroundColor: COLORS.ACTIVITY[activityTypeMap[type].backgroundColor],
        color: COLORS.ACTIVITY[activityTypeMap[type].colorLabel],
      }}
    />
    <div style={styles.id}>{`#${activityId}`}</div>
  </div>
);

export default ActivityTypeAndId;
